import { createContext, useContext } from "react";

export const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);
export const isManager = (me) => me && ["owner", "manager"].includes(me.role);
